import { useEffect, useRef, useState } from "react"
import { Flex, Form, Checkbox } from "antd"
import { QuestionCircleOutlined } from "@ant-design/icons"
import { getActiveSetValue, getConditionalRevertValue, shouldRevertConditionalValue } from "../../../utils/formsHelper";


const MultipleChoiceInput = (props) => {
    const { label, tooltip, helpText, mandatory, highlight=false, layout = false, readOnly, options = [], sort, id, form, formValues, previewMode, setValueData, enableScoring = false, maxSelectableOptions, ...rest } = props
    const rules = mandatory ? [{ required: true }] : undefined;
    const disabled = previewMode && readOnly ? true : false
    const help = tooltip ? { title: helpText, icon: <QuestionCircleOutlined /> }
        : undefined;
    let selectOptions = (options || []).filter(opt => opt.label)

    if (sort === "ascending") {
        selectOptions.sort((a, b) => a.label.localeCompare(b.label));
    } else if (sort === "descending") {
        selectOptions.sort((a, b) => b.label.localeCompare(a.label));
    }

    // When scoring is enabled, cap selections at maxSelectableOptions: once the
    // cap is hit, disable the unchecked options (checked ones stay removable).
    const selectedValues = Array.isArray(formValues?.[id]) ? formValues[id] : []
    const selectionLimit = enableScoring && maxSelectableOptions != null ? Number(maxSelectableOptions) : undefined
    const limitReached = selectionLimit != null && selectedValues.length >= selectionLimit
    selectOptions = selectOptions.map(opt => ({
        ...opt,
        disabled: opt.disabled || (limitReached && !selectedValues.includes(opt.value)),
    }))

    let activeSetValue = getActiveSetValue(setValueData)

    // Track the condition value already applied so an editable field is prefilled
    // only once. Disabled fields stay locked to the condition value.
    const lastAppliedConditionalRef = useRef(undefined)
    // The selection actually written to the form - the condition carries it as a
    // JSON string, so it is not comparable with the value the field holds.
    const appliedFormValueRef = useRef(undefined)

    useEffect(() => {
        if (activeSetValue?.value) {
            const key = activeSetValue.value
            const applyValue = () => {
                const mcqValues = typeof activeSetValue?.value === "string" ? JSON.parse(activeSetValue?.value) : [activeSetValue?.value]
                form?.setFieldValue(id, mcqValues)
                appliedFormValueRef.current = mcqValues
            }
            if (disabled) {
                applyValue()
            } else if (lastAppliedConditionalRef.current !== key) {
                applyValue()
            }
            lastAppliedConditionalRef.current = key
        } else if (shouldRevertConditionalValue(activeSetValue, { disabled, currentValue: form?.getFieldValue(id), appliedValue: appliedFormValueRef.current })) {
            form?.setFieldValue(id, getConditionalRevertValue(id, props.defaultFormValues))
            lastAppliedConditionalRef.current = undefined
            appliedFormValueRef.current = undefined
        } else {
            lastAppliedConditionalRef.current = undefined
            appliedFormValueRef.current = undefined
        }
    }, [activeSetValue, disabled, form, id])

    return (
        <div className="form-element">
            <Flex vertical>
                <Form.Item name={id} tooltip={help} rules={rules} messageVariables={{ label }} className={layout ? "vertical-group" : "horizontal-group"}
                    label={<span
                    style={{
                        color: (highlight && !rest.isPublicForm) ? "#722ed1" : "inherit",
                        fontWeight: (highlight && !rest.isPublicForm) ? 600 : 400,
                        background: (highlight && !rest.isPublicForm) ? "#f5eeff" : "transparent",
                        padding: "2px 6px",
                        borderRadius: 4,
                    }}
                >
                    {label}
                </span>}
                >
                <Checkbox.Group options={selectOptions} disabled={readOnly} style={{ display: layout ? "flex" : "flex", flexDirection: layout ? "column" : "row", gap: "8px" }} />
            </Form.Item>
        </Flex>
        </div >
    )
}

export default MultipleChoiceInput